// usePersistedState.js (crea este archivo en tu proyecto)
import { useState, useEffect } from 'react';

function usePersistedState(key, defaultValue, prefix = '') {
  const fullKey = prefix ? `${prefix}_${key}` : key;
  
  // Inicializar estado desde localStorage
  const [state, setState] = useState(() => {
    try {
      const saved = localStorage.getItem(fullKey);
      return saved !== null ? JSON.parse(saved) : defaultValue;
    } catch (e) {
      console.error(`Error cargando estado para ${fullKey}:`, e);
      return defaultValue;
    }
  });
  
  // Guardar en localStorage cuando cambia
  useEffect(() => {
    try {
      localStorage.setItem(fullKey, JSON.stringify(state));
    } catch (e) {
      console.error(`Error guardando estado para ${fullKey}:`, e);
    }
  }, [fullKey, state]);
  
  return [state, setState];
}

export default usePersistedState;